import { createAction, createAsyncAction } from 'typesafe-actions';
import { MemberDetails } from './types';

interface FetchLoyaltyMemberDetailsPayload {
  aliasOrId: string;
  searchSource?: string;
}

const fetchLoyaltyMemberDetails = createAsyncAction(
  '@loyalty/memberDetails/fetch',
  '@loyalty/memberDetails/success',
  '@loyalty/memberDetails/error'
)<FetchLoyaltyMemberDetailsPayload, MemberDetails, unknown>();

const resetLoyaltyMemberDetailsStore = createAction('@loyalty/memberDetails/resetStore', action => () => action());
const updateLoyaltyMemberDetailsStoreStatus = createAction(
  '@loyalty/memberDetails/updateStoreStatus',
  action => (account: string) => action(account)
);

export const loyaltyMemberDetailsActions = {
  fetchLoyaltyMemberDetails,
  resetLoyaltyMemberDetailsStore,
  updateLoyaltyMemberDetailsStoreStatus
};
